export default __webpack_public_path__ + "static/media/Ambriza-Training.80feff1d.jpg";